import { Component, Host, h, State, Prop } from "@stencil/core";
import { ObservableMap } from "@stencil/store";
import { getStore, ILiftStatusState } from "../../store";
import { sensorInfo } from "../../utils/sensorInfo";
import {
  ILiftStatusSensorDataResponse,
  ILiftStatusValues,
} from "../../utils/types";

@Component({
  tag: "ls-indicator",
  styleUrl: "ls-indicator.css",
  shadow: true,
})
export class LsIndicator {
  /**
   * The ID of the sensor that is to be displayed.
   */
  @Prop() readonly sensorId: number;

  @State() dataLabel: string;
  @State() sensorData: ILiftStatusValues;

  /**
   * The unique key that is used to identify store data.
   */
  @Prop() readonly idKey: string;

  private store: ObservableMap<ILiftStatusState>;

  private processSensorUpdate = (sensorData: ILiftStatusSensorDataResponse) => {
    let sensorValues = sensorData.values;

    // The sensor values of 501 and 514 and 515 are zero based, but we need to show them one based
    this.sensorData =
      sensorValues[this.sensorId] === ""
        ? sensorValues[this.sensorId]
        : sensorValues[this.sensorId] + 1;
  };

  async componentWillLoad() {
    this.store = await getStore(this.idKey);

    this.processSensorUpdate(this.store.state.currentSensorData);

    this.store.onChange("currentSensorData", (sensorData) => {
      this.processSensorUpdate(sensorData);
    });

    this.dataLabel = sensorInfo.getShortLabel(this.sensorId);
  }

  render() {
    if (this.sensorId === null) {
      console.group(
        "%cError%c [LsIndicator] No sensor ID supplied",
        "color: #DC2626; background-color: #FEF2F2; display: inline-block; padding: 0 4px; border-radius: 2px;",
        ""
      );
      console.log(
        `Add the ID to the LsIndicator component like so: %c<ls-indicator sensor-id="yourId"></ls-indicator>%c`,
        "color:#27272A; background-color: #E4E4E7; display: inline-block; padding: 0 4px; border-radius: 2px;",
        ""
      );
      console.groupEnd();
    }

    return (
      <Host>
        <div class="label">
          {this.sensorId === null ? "No ID supplied" : this.dataLabel}
        </div>
        <div class="backdrop">00</div>
        <div class="indicator">{this.sensorData || ""}</div>
      </Host>
    );
  }
}
